import { createReducer, on } from '@ngrx/store';
import { SessionState, initialSessionState } from '../state/session.state';
import {
  loadSession,
  loadSessionSuccess,
  loadSessionFailure,
} from '../actions/session.actions';

export const sessionReducer = createReducer(
  initialSessionState,
  on(
    loadSession,
    (state): SessionState => ({
      ...state,
      participant: null,
      signing: null,
      isLoading: true,
      error: null,
    }),
  ),
  on(
    loadSessionSuccess,
    (state, { participant, signing }): SessionState => ({
      ...state,
      participant,
      signing,
      isLoading: false,
      error: null,
    }),
  ),
  on(
    loadSessionFailure,
    (state, { error }): SessionState => ({
      ...state,
      isLoading: false,
      error,
    }),
  ),
);
